import { useState, useEffect } from 'react';
import MainApp from './MainApp';
import { AdminPanel } from './components/AdminPanel';

function App() {
  const [isAdmin, setIsAdmin] = useState(() => {
    // Check URL hash or path for admin route
    const hash = window.location.hash;
    const path = window.location.pathname;
    return hash === '#admin' || path.includes('admin');
  });

  useEffect(() => {
    const onHashChange = () => {
      setIsAdmin(window.location.hash === '#admin');
    };
    window.addEventListener('hashchange', onHashChange);
    return () => window.removeEventListener('hashchange', onHashChange);
  }, []);

  // Set body class for admin page (allows scrolling)
  useEffect(() => {
    document.body.classList.toggle('admin-body', isAdmin);
  }, [isAdmin]);

  if (isAdmin) {
    return <AdminPanel />;
  }

  return <MainApp />;
}

export default App;
